import { convertCase } from '../../_utils/utils'
import * as clone from 'clone'
import { stripUndefined } from '../../_utils/strip-undefined'

export type SubscriberFrequencyCapType = 'once' | 'once_per_criteria'
export type SubscriberFrequencyCapWindow = 'days' | 'weeks' | 'months' | 'years'

export class RecurrenceSubscriberFrequencyCap {
    public static build(props: RecurrenceSubscriberFrequencyCap | any): RecurrenceSubscriberFrequencyCap {
        const data = props instanceof RecurrenceSubscriberFrequencyCap ? props.serialize() : clone(props)
        const scData = convertCase(data, 'snake')

        const model = new RecurrenceSubscriberFrequencyCap()
        model.setType(data.type)
        if (model.getType() === 'once_per_criteria') {
            model.setFrequency(scData.criteria?.frequency)
            model.setWindow(scData.criteria?.window)
        }

        return model
    }

    private type: SubscriberFrequencyCapType
    private frequency?: number
    private window?: SubscriberFrequencyCapWindow

    public clone(): RecurrenceSubscriberFrequencyCap {
        return RecurrenceSubscriberFrequencyCap.build(this)
    }

    public serialize(_: boolean = true): any {
        const serialized: any = {
            type: this.getType(),
        }

        if (serialized.type === 'once_per_criteria') {
            serialized.criteria = {
                frequency: this.getFrequency(),
                window: this.getWindow(),
            }
        }

        return stripUndefined(serialized)
    }

    public setType(type: SubscriberFrequencyCapType): void {
        this.type = type

        if (type === 'once') {
            this.frequency = undefined
            this.window = undefined
        }
    }
    public getType(): SubscriberFrequencyCapType {
        return this.type
    }

    public setFrequency(frequency: number | undefined): void {
        if (frequency !== undefined) {
            if (String(frequency) !== '' && !isNaN(frequency)) {
                frequency = parseInt(frequency.toString(), 10)
            }
        }

        this.frequency = frequency
    }
    public getFrequency(): number | undefined {
        return this.frequency
    }

    public setWindow(window: SubscriberFrequencyCapWindow | undefined): void {
        this.window = window
    }
    public getWindow(): SubscriberFrequencyCapWindow | undefined {
        return this.window
    }
}
